import {
  CompetitionStageDto,
  PortalLifecycleStatus,
  type PortalSourcingEventSummaryDto,
} from "../../../../autogen/bff-api";
import { isInvitedCompetition } from "../isInvitedCompetition";
import { entersByInvitation } from "./entersByInvitation";
import { isSchemeProcedure } from "../../../../common/procurement/procedure";

// t('Register interest') t('Log in to register interest') t('Request to participate') t('Log in to request participation')
// t('Apply to join') t('Log in to apply to join')
export const nextStepKey = (
  event: Pick<
    PortalSourcingEventSummaryDto,
    "lifecycle" | "competitionStage" | "contextType" | "viewerMayTakeNextStep" | "procedureType" | "viewerInvited"
  >,
  { hasBid, signedIn }: { hasBid: boolean; signedIn: boolean },
): string | null => {
  const invitedHere = isInvitedCompetition(event.contextType) && event.viewerInvited === true;
  if (hasBid || event.lifecycle.status !== PortalLifecycleStatus.Open || invitedHere) {
    return null;
  }
  if (signedIn && event.viewerMayTakeNextStep !== true) return null;
  switch (event.competitionStage) {
    case CompetitionStageDto.RequestsOpen:
      if (isSchemeProcedure(event.procedureType)) return signedIn ? "Apply to join" : "Log in to apply to join";
      return signedIn ? "Request to participate" : "Log in to request participation";
    case CompetitionStageDto.InterestOpen:
    case null:
    case undefined:
      if (entersByInvitation(event)) return null;
      return signedIn ? "Register interest" : "Log in to register interest";
    default:
      return null;
  }
};
